/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

/**
 * If on a Macintosh with an extended keyboard, the Enter key located in the
 * numeric pad has a different ASCII code.
 */
export const MAC_ENTER = 3;

/** The Enter key. */
export const ENTER = 13;

/** The Space key. */
export const SPACE = 32;

/** Special keycodes used by jsaction for the generic click action. */
export const KeyCode = {MAC_ENTER, ENTER, SPACE};
